import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from 'antd';

import BRButton from 'components/BRButton/BRButton';

import { ADD_PRODUCTS_MODAL_CONTENT } from 'constants/products';

import { ReactComponent as CloseIcon } from 'assets/bosta-icons/Close.svg';

import './AddProductModal.less';

const AddProductModal = ({ intl, close, onCardClick = () => {}, ...props }) => {
  return (
    <Modal
      className="br-add-product-modal"
      {...props}
      footer={null}
      width={null}
      title={null}
      onCancel={close}
    >
      <div className="br-add-product-modal__title">
        <span className="display-xs">
          {intl.formatMessage({ id: 'products.add_products_modal.title' })}
        </span>
        <BRButton
          type="treitary-gray"
          suffixIcon={<CloseIcon />}
          onClick={close}
        />
      </div>
      <div className="br-add-product-modal__content">
        {ADD_PRODUCTS_MODAL_CONTENT.map(({ icon, title, subtitle }, index) => (
          <div
            key={index}
            className="br-add-product-modal__content-card"
            onClick={() => {
              close();
              onCardClick({ key: `${index}`, hoverOrClick: 'CLICK' });
            }}
          >
            <span className="br-add-product-modal__content-card__icon">
              {icon}
            </span>
            <span className="br-add-product-modal__content-card__text">
              <span className="body-medium">{title}</span>
              <span>{subtitle}</span>
            </span>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default injectIntl(AddProductModal);
